import { TimePeriod, TimeRange } from "@smart/itops-sb-design-system-dom";

export type HomeTabKey = "web-enquiries" | "pending-forms" | "completed-forms";

const FILTER_MAP = {
  "web-enquiries": {
    widgetFilterKey: "intake-home-web-enquiries-filter",
    tableFilterKey: "receivedAt-date-filter",
    columnId: "receivedAt",
    tableId: "intake-web-enquiries",
  },
  "pending-forms": {
    tableFilterKey: "shared-at-date-filter",
    columnId: "shared-at",
    tableId: "intake-pending-submissions",
    period: "allTime" as const,
  },
  "completed-forms": {
    widgetFilterKey: "intake-home-completed-intake-forms-filter",
    tableFilterKey: "completedOn-date-filter",
    columnId: "completedOn",
    tableId: "intake-completed-submissions",
  },
} as const;

const readStorage = <T>(storage: Storage, key: string): T | undefined => {
  const value = storage.getItem(key);
  if (!value) return undefined;

  try {
    return JSON.parse(value) as T;
  } catch {
    return undefined;
  }
};

const writeStorage = (storage: Storage, key: string, value: unknown) => {
  if (value) {
    storage.setItem(key, JSON.stringify(value));
  } else {
    storage.removeItem(key);
  }
};

export const syncWidgetFilterToTable = (
  tabKey: HomeTabKey,
): { period: TimePeriod; range?: TimeRange } => {
  const mapping = FILTER_MAP[tabKey];

  const period =
    "period" in mapping
      ? mapping.period
      : (readStorage<TimePeriod>(localStorage, mapping.widgetFilterKey) ??
        "thisWeek");
  const range =
    "widgetFilterKey" in mapping
      ? readStorage<TimeRange>(localStorage, `${mapping.widgetFilterKey}-range`)
      : undefined;

  writeStorage(localStorage, mapping.tableFilterKey, period);
  writeStorage(
    localStorage,
    `${mapping.tableFilterKey}-range`,
    range?.from && range?.to ? range : undefined,
  );

  const columnFiltersKey = `${mapping.tableId}-column-filters`;
  const filterValue = { period, range };
  writeStorage(sessionStorage, columnFiltersKey, [
    { id: mapping.columnId, value: filterValue },
  ]);

  return { period, range };
};
